// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DotDotDot-module__hiddenDot--REUZ0,
.DotDotDot-module__shownDot--TwwPT {
  transition: color 0.2s;
}

.DotDotDot-module__shownDot--TwwPT {
  color: var(--theater-tertiary-button-background-color);
}

.DotDotDot-module__hiddenDot--REUZ0 {
  color: var(--transparent);
}`, "",{"version":3,"sources":["webpack://./src/components/DotDotDot/DotDotDot.module.scss"],"names":[],"mappings":"AAAA;;EAEC,sBAAA;AACD;;AACA;EACC,sDAAA;AAED;;AAAA;EACC,yBAAA;AAGD","sourcesContent":[".hiddenDot,\n.shownDot {\n\ttransition: color 0.2s;\n}\n.shownDot {\n\tcolor: var(--theater-tertiary-button-background-color);\n}\n.hiddenDot {\n\tcolor: var(--transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hiddenDot": `DotDotDot-module__hiddenDot--REUZ0`,
	"shownDot": `DotDotDot-module__shownDot--TwwPT`
};
export default ___CSS_LOADER_EXPORT___;
